import { hydrateRoot } from "react-dom/client";
import { Store } from "@ludens-reklame/rubics-v3-sdk/store";
import App from "./App.tsx";

declare global {
  interface Window {
    _STORE: Store<any, any>;
  }
}

hydrateRoot(document.getElementById("app")!, <App store={window._STORE} />);
